module.exports = __webpack_public_path__ + "media/images/products/intro/3-792e6e810b78765fecd05d02aa86e074.svg";